import { useIntl } from 'react-intl';
import { IconTooltip } from 'sonata-react-components';

import './pacingColorLegend.scss';

const PACING_STATUSES = ['well', 'bad', 'reallyBad', 'tooMuch', 'noData'] as const;

export function PacingColorLegend(): JSX.Element {
  const { formatMessage } = useIntl();

  const labels: Record<(typeof PACING_STATUSES)[number], string> = {
    bad: formatMessage({
      defaultMessage: 'Pacing of some elements is not going so well',
      id: 'pacingStatusModal.legend.bad'
    }),
    noData: formatMessage({ defaultMessage: 'There is no pacing information', id: 'pacingStatusModal.legend.noData' }),
    reallyBad: formatMessage({
      defaultMessage: 'Pacing is not going well in your campaign',
      id: 'pacingStatusModal.legend.reallyBad'
    }),
    tooMuch: formatMessage({
      defaultMessage: 'Pacing must be checked, it’s consumoing more than expected',
      id: 'pacingStatusModal.legend.tooMuch'
    }),
    well: formatMessage({
      defaultMessage: 'Pacing is going well in your campaign',
      id: 'pacingStatusModal.legend.well'
    })
  };

  return (
    <div className="pacingColorLegend">
      <span className="pacingColorLegend__label">
        {formatMessage({ defaultMessage: 'Pacing color legend', id: 'pacingStatusModal.legend.title' })}
      </span>
      <IconTooltip
        customClassName="pacingColorLegendPanel"
        event="mouseenter"
        icon="fa-regular fa-circle-info"
        iconColor="var(--color-sonata-primary-500, #7B9FE1) !important"
        place="bottom-end"
        portal
      >
        <ul className="pacingColorLegend__list">
          {PACING_STATUSES.map(status => (
            <li className="pacingColorLegend__item" key={status}>
              <span className={`pacingColorLegend__swatch pacingColorLegend__swatch--${status}`} />
              <span>{labels[status]}</span>
            </li>
          ))}
        </ul>
      </IconTooltip>
    </div>
  );
}
